import React from "react";
import { createRoot } from "react-dom/client";

// Les fontes AVANT le reste : elles sont servies depuis notre domaine, et leur
// déclaration doit précéder la feuille qui les référence.
import "@fontsource-variable/inter";
import "@fontsource-variable/playfair-display";
import "./typography.css";

import { App } from "./App.js";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
